module.exports = __webpack_public_path__ + "img/americanexpress.425da723.svg";